import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=27d5c536&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=27d5c536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5c536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d5c536')) {
      api.createRecord('27d5c536', component.options)
    } else {
      api.reload('27d5c536', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=27d5c536&scoped=true&", function () {
      api.rerender('27d5c536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22iLSi91dX5R6/JS/teamMember.vue"
export default component.exports